import Vue from "vue";

const components = {
  Input: () => import("./Input.vue"),
  HlButton: () => import("./HlButton.vue"),
  Toggle: () => import("./Toggle.vue"),
  Heading: () => import("./Heading.vue")
};

Object.entries(components).forEach(([name, component]) =>
  Vue.component(name, component)
);
